export const HELP_DESK_TICKETS = '/hd-tickets/' as const
export const HELP_DESK_TICKETS_ALL = `${HELP_DESK_TICKETS}all` as const
export const HELP_DESK_TICKETS_OWN = `${HELP_DESK_TICKETS}own` as const
